import { css } from '@microsoft/fast-element';
import { gridButtonStyling } from '../../../styles';

export const ThirdPartyStyles = css`
  :host {
    height: 100%;
  }
`;
